<template>
    <span v-if="orderBy==field" class="icon">
        <i class="fas" :class="[direction==='asc' ? 'fa-sort-up' : 'fa-sort-down']"/>
    </span>
</template>

<script>
export default {
    props: ['orderBy', 'field', 'direction'],
}
</script>